// extracted by mini-css-extract-plugin
module.exports = {"component":"pill-badge-component--10OrA"};